/**
 * Hjælpere til social-share — udskilt fra ShareButton-komponenten så
 * komponenten holdes simpel og udskilte funktioner kan unit-testes.
 */

const POPUP_OPTS = "noopener,noreferrer,width=560,height=520";

export function shareToX({ url, title, hashtags = [], via = "" }) {
    const params = new URLSearchParams({ text: title, url });
    if (hashtags.length) params.set("hashtags", hashtags.join(","));
    if (via) params.set("via", via.replace(/^@/, ""));
    window.open(`https://twitter.com/intent/tweet?${params}`, "_blank", POPUP_OPTS);
}

export function shareToLinkedIn({ url }) {
    const params = new URLSearchParams({ url });
    window.open(`https://www.linkedin.com/sharing/share-offsite/?${params}`, "_blank", POPUP_OPTS);
}

export function shareToFacebook({ url }) {
    const params = new URLSearchParams({ u: url });
    window.open(`https://www.facebook.com/sharer/sharer.php?${params}`, "_blank", POPUP_OPTS);
}

export async function copyLink(url) {
    try {
        await navigator.clipboard.writeText(url);
        return true;
    } catch {
        // Fallback for ældre browsere
        window.prompt("Kopiér link:", url);
        return false;
    }
}

export async function tryNativeShare({ url, title }) {
    if (!navigator.share) return false;
    try {
        await navigator.share({ title, url });
        return true;
    } catch {
        return false; // bruger annullerede
    }
}

export function isMobileShareCapable() {
    return Boolean(navigator.share)
        && /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
}
